import React from 'react';
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  linearProgress: {
    minWidth: '400px',
  },
  subTitleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
}));

const ProgressLinear = ({size = 50, title = '', progressTitle, replaceAllText = false, progressValue}) => {
  const classes = useStyles();

  return (
    <Dialog maxWidth="md" open={true}>
      <DialogTitle id={title}>
        <Typography variant="overline">{replaceAllText ? `${title}... ` : `Loading ${title}... `}</Typography>
      </DialogTitle>
      <DialogContent>
        <div className={classes.subTitleSection}>
          <CircularProgress size={size} />
          <p>{progressTitle}</p>
        </div>
        <LinearProgress className={classes.linearProgress} value={progressValue} variant="determinate" />
        <br />
      </DialogContent>
    </Dialog>
  );
};

ProgressLinear.propTypes = {
  progressTitle: PropTypes.string,
  progressValue: PropTypes.number,
  replaceAllText: PropTypes.bool,
  size: PropTypes.number,
  title: PropTypes.string,
};

export default ProgressLinear;
